/** レポートデータ更新画面: データ確定の確認モーダル（SR-039）。実行処理は onExecute を呼び出し元で行う。 */
'use strict'

import * as React from 'react'
import { useStore } from 'react-redux'
import { useModal, useModalExtra } from '../../../../_components/Modal'
import { useModifyClassList } from '../../../../common/utils/CSSUtils'
import { useReportDataUpdateStore } from '../extra/store'
import { DATA_FIX_STATUS_FIX } from '../extra/types'

/**
 * @param {{
 *   onExecute: (args: {
 *     userSub: string
 *     userName: string
 *     key: { CorporationNumber: string; Key: string | number }
 *   }) => Promise<void>
 *   onPageError?: (message: string) => void
 *   globalReduxStore?: import('redux').Store
 * }} options
 *   ReportDataUpdateProvider 配下では useStore がローカルストアのため、親からアプリ全体の Store を渡す
 * @returns {() => Promise<void>}
 */
export function useDataFixConfirmModal(options) {
  const { onExecute, onPageError, globalReduxStore: globalReduxStoreOpt } = options ?? {}
  const showModal = useModal()
  const { _closeUpModal } = useModalExtra()
  const { promisify } = useModifyClassList('.modal-window', ['w-[600px]'])
  const localStore = useStore()
  const reportStore = useReportDataUpdateStore()
  const globalReduxStore = globalReduxStoreOpt ?? localStore

  return React.useCallback(() => {
    return promisify((res) => {
      showModal({
        title: 'データ確定の確認',
        description: (
          <div className="text-body grey--text text-center px-2">
            <p>データを確定します。よろしいですか？</p>
          </div>
        ),
        isWide: false,
        isCancel: true,
        cancelName: 'キャンセル',
        onClose: res,
        button: [
          {
            name: '実行',
            className: 'footer-btn button_base',
            close: false,
            click: async () => {
              try {
                const rs = reportStore.getState()
                if (rs.dataCreateTask?.dataFixStatus === DATA_FIX_STATUS_FIX) {
                  onPageError?.('データ確定済のため実行できません。')
                  return
                }
                const taskKey = rs.dataCreateTaskKey
                const gst = globalReduxStore.getState()
                const userSub = String(gst.user?.sub ?? '')
                const userName = String(gst.user?.userName ?? '')
                const corporationNumber = String(gst.company?.corporationNumber ?? '').trim()
                if (!userSub || taskKey === null || taskKey === undefined || !corporationNumber) {
                  onPageError?.('処理を実行できません。')
                  return
                }
                const key = { CorporationNumber: corporationNumber, Key: taskKey }
                try {
                  await onExecute?.({ userSub, userName, key })
                } catch (err) {
                  console.error(err)
                  onPageError?.('分析データ確定処理でエラーが発生しました。')
                }
              } finally {
                _closeUpModal()
                res()
              }
            }
          }
        ]
      })
    })
  }, [_closeUpModal, globalReduxStore, onExecute, onPageError, promisify, reportStore, showModal])
}
